// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__NXG3X","summary":"CartItem_summary__VOm4u","price":"CartItem_price__fMnpa","amount":"CartItem_amount__VHfwq","actions":"CartItem_actions__YM-8O"};